import { ButtonPrimary } from '@/components/button'
import { Close } from '@/components/icons'
import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PlayerItem } from './BracketTeams'

type Props = {
  open: boolean
  onClose: () => void
  title: string
  onSubmit: (params?: any) => any
  waitListTeams: any
}

export const ReplaceTeamModal = ({ open, onClose, title, onSubmit, waitListTeams }: Props) => {
  const { t } = useTranslation()

  const [selectedTeam, setSelectedTeam] = useState<any>(null)

  const BgColor = (value: string) => {
    if (value === 'CONFIRMED') return 'bg-green'
    if (value === 'NOT_CONFIRMED') return 'bg-warn'
    return 'bg-slate-500'
  }

  const ContentColor = (value: string) => {
    if (value === 'CONFIRMED') return 'text-green'
    if (value === 'NOT_CONFIRMED') return 'text-warn'
    return 'text-slate-500'
  }

  const EventStatusCase = (value: string) => {
    if (value === 'CONFIRMED') return t('event.teamConfirmed')
    if (value === 'NOT_CONFIRMED') return t('event.teamPending')
    return value
  }

  useEffect(() => {
    setSelectedTeam(null)
  }, [open])

  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full flex flex-col gap-y-4 max-w-4xl transform overflow-hidden rounded-2xl bg-white px-6 py-4 text-left align-middle shadow-xl transition-all relative">
                <button
                  className="w-9 h-9 rounded-full bg-navy-900 bg-opacity-10 flex items-center justify-center ml-2 hover:bg-opacity-20 absolute right-2 top-2"
                  onClick={onClose}
                >
                  <Close className="text-navy-900" />
                </button>

                <Dialog.Title as="h3" className="text-xl text-navy-900 font-semibold">
                  {title}
                </Dialog.Title>

                <div className="px-10">
                  <p className="text-sm text-navy-900 text-opacity-70">{t('event.replaceTeamDesc')}</p>
                </div>

                <div className="max-h-96 overflow-y-auto flex flex-col gap-y-2">
                  {waitListTeams?.map((item: any) => {
                    const checked = item?.registrationId === selectedTeam?.registrationId

                    return (
                      <div className="flex items-center gap-x-4" key={item?.registrationId}>
                        <div className="flex items-center">
                          <input
                            type="checkbox"
                            className={`w-5 h-5`}
                            checked={checked}
                            onChange={() => setSelectedTeam(item)}
                          />
                        </div>
                        <div className="flex flex-1 bg-white rounded p-4 border">
                          <div className="flex flex-1 flex-col gap-y-3">
                            <div className="flex">
                              <p
                                className={`${BgColor(item?.partnerStatus)} ${ContentColor(
                                  item?.partnerStatus
                                )} bg-opacity-20 rounded-lg px-2 h-6 flex items-center font-medium text-xs`}
                              >
                                {EventStatusCase(item?.partnerStatus)}
                              </p>
                            </div>
                            <div className="flex flex-col gap-y-3 flex-1">
                              <div className="flex justify-between bg-white">
                                <PlayerItem player={item?.player1} />
                              </div>

                              <div className="flex justify-between bg-white">
                                <PlayerItem player={item?.player2} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  })}
                </div>

                <div className="flex  justify-center gap-x-6">
                  <button
                    className="py-[6px] px-10 rounded text-sm text-navy-900 font-semibold border shadow-md hover:bg-slate-100"
                    onClick={onClose}
                  >
                    {t('common.back')}
                  </button>
                  <ButtonPrimary
                    title={t('common.next')}
                    className="!py-[6px] !px-10 !rounded"
                    onClick={() => onSubmit(selectedTeam)}
                    disabled={!selectedTeam}
                  />
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}
